import { instantClientDB } from "instantdb/instantClient";

// Check if user exists
async function checkUserExistsClient(userId: string) {
  const user = await instantClientDB.useQuery({
    users: {
      $: {
        where: {
          id: userId,
        },
      },
    },
  });

  if (!user) {
    throw new Error("User not found");
  }

  return user.data?.users[0];
}

// Update user email
export async function updateUserEmail({
  userId,
  email,
}: {
  userId: string;
  email: string;
}) {
  await checkUserExistsClient(userId);

  await instantClientDB.transact([
    instantClientDB.tx.users[userId].update({
      email,
      updatedAt: new Date().toISOString(),
    }),
  ]);

  return { success: true };
}

// Cancel subscription
export async function cancelSubscriptionClient({ userId }: { userId: string }) {
  await checkUserExistsClient(userId);

  await instantClientDB.transact([
    instantClientDB.tx.users[userId].update({
      proStatus: "canceled",
      updatedAt: new Date().toISOString(),
    }),
  ]);
}
